// extracted by mini-css-extract-plugin
export var childPages = "ArticleTagList-module--childPages--c4tOQ";
export var footer = "ArticleTagList-module--footer--9b1Cg";
export var siblingPages = "ArticleTagList-module--siblingPages--a3QPj";